import React from "react";

import "./styles.scss";

/*
Enums:
Status ["active", "pending", "construction","planning","syncing","offline"]
*/

const StatusButton = ({ title, status }) => {
  return (
    <div className="status-button" data-status={status}>
      <p>{title}</p>
    </div>
  );
};

export default StatusButton;
